import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import {
  Country,
  Currency,
  IdentificationMethod,
  SettingsModel,
  Timezone,
} from "types/settings";

export interface InitialState {
  tenant: SettingsModel;
  countries: Country[];
  identificationMethods: IdentificationMethod[];
  timezones: Timezone[];
  currencies: Currency[];
}

const initialState: InitialState = {
  tenant: {},
  countries: [],
  identificationMethods: [],
  timezones: [],
  currencies: [],
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setTenantSettings: (state, action: PayloadAction<SettingsModel>) => {
      state.tenant = action.payload;
    },
    setCountries: (state, action: PayloadAction<Country[]>) => {
      state.countries = action.payload;
    },
    setIdentificationMethods: (
      state,
      action: PayloadAction<IdentificationMethod[]>,
    ) => {
      state.identificationMethods = action.payload;
    },
    setTimezones: (state, action: PayloadAction<Timezone[]>) => {
      state.timezones = action.payload;
    },
    setCurrencies: (state, action: PayloadAction<Currency[]>) => {
      state.currencies = action.payload;
    },
  },
});

export const {
  setTenantSettings,
  setCountries,
  setIdentificationMethods,
  setTimezones,
  setCurrencies,
} = settingsSlice.actions;

export const getTenantSettings = (state: RootState) => state.settings.tenant;

export const getCountries = (state: RootState) => state.settings.countries;

export const getIdentificationMethods = (state: RootState) =>
  state.settings.identificationMethods;

export const getTimezones = (state: RootState) => state.settings.timezones;

export const getCurrencies = (state: RootState) => state.settings.currencies;

export default settingsSlice.reducer;
